import { DsgBinaryLatest, DsgEcrToken } from '../types';
import { requestWithOptions } from './helper';

const basePath = import.meta.env.REACT_APP_API_ENDPOINT_ACCOUNTS || '/';

export const getDsgBinaryLatest = async () => {
  const options = {
    method: 'GET',
  };

  const path = `${basePath}/dsg/binary/latest`;

  const response = await requestWithOptions(path, options);
  return response as DsgBinaryLatest;
};

export const getDsgEcrToken = async () => {
  const options = {
    method: 'GET',
  };

  const path = `${basePath}/dsg/ecr/token`;

  const response = await requestWithOptions(path, options);
  return response as DsgEcrToken;
};
